export const pennsylvania = {
  "42000": "Pennsylvania",
  "42001": "Adams County",
  "42003": "Allegheny County",
  "42005": "Armstrong County",
  "42007": "Beaver County",
  "42009": "Bedford County",
  "42011": "Berks County",
  "42013": "Blair County",
  "42015": "Bradford County",
  "42017": "Bucks County",
  "42019": "Butler County",
  "42021": "Cambria County",
  "42023": "Cameron County",
  "42025": "Carbon County",
  "42027": "Centre County",
  "42029": "Chester County",
  "42031": "Clarion County",
  "42033": "Clearfield County",
  "42035": "Clinton County",
  "42037": "Columbia County",
  "42039": "Crawford County",
  "42041": "Cumberland County",
  "42043": "Dauphin County",
  "42045": "Delaware County",
  "42047": "Elk County",
  "42049": "Erie County",
  "42051": "Fayette County",
  "42053": "Forest County",
  "42055": "Franklin County",
  "42057": "Fulton County",
  "42059": "Greene County",
  "42061": "Huntingdon County",
  "42063": "Indiana County",
  "42065": "Jefferson County",
  "42067": "Juniata County",
  "42069": "Lackawanna County",
  "42071": "Lancaster County",
  "42073": "Lawrence County",
  "42075": "Lebanon County",
  "42077": "Lehigh County",
  "42079": "Luzerne County",
  "42081": "Lycoming County",
  "42083": "Mc Kean County",
  "42085": "Mercer County",
  "42087": "Mifflin County",
  "42089": "Monroe County",
  "42091": "Montgomery County",
  "42093": "Montour County",
  "42095": "Northampton County",
  "42097": "Northumberland County",
  "42099": "Perry County",
  "42101": "Philadelphia County",
  "42103": "Pike County",
  "42105": "Potter County",
  "42107": "Schuylkill County",
  "42109": "Snyder County",
  "42111": "Somerset County",
  "42113": "Sullivan County",
  "42115": "Susquehanna County",
  "42117": "Tioga County",
  "42119": "Union County",
  "42121": "Venango County",
  "42123": "Warren County",
  "42125": "Washington County",
  "42127": "Wayne County",
  "42129": "Westmoreland County",
  "42131": "Wyoming County",
  "42133": "York County",
};
